import React from 'react';
import './PageHeader.scss';

interface PageHeaderProps {
    text: string;
}

const PageHeader: React.FunctionComponent<PageHeaderProps> = ({ text }) => {
  return <div className="page-title">{text}</div>;
};

export default PageHeader;